import React, { Component } from 'react';
import { bool, instanceOf, string, func } from 'prop-types';
import { scroller } from 'react-scroll';
import styled from 'styled-components';
import { withCookies, Cookies } from 'react-cookie';

const Container = styled.div`
  transition: all 0.2s;
  opacity: ${({ show }) => (show ? '1' : '0')};
  visibility: ${({ show }) => (show ? 'visible' : 'hidden')};
`;

const CoverScreen = styled.div`
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 1001;
  position: fixed;
  opacity: 0.5;
  background-color: #090909;
`;

const HeaderCoverScreen = styled.div`
  top: 0;
  height: 80px;
  right: 0;
  left: 0;
  z-index: 1011;
  position: fixed;
  opacity: 0.5;
  background-color: #090909;
`;

const TooltipBubble = styled.div`
  position: absolute;
  border-radius: 8px;
  width: 240px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.32);
  background-color: #fff;
  padding: 16px;
  z-index: 1002;
  bottom: 30px;
  transform: translateX(-50%);

  &:after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 48%;
    width: 0;
    height: 0;
    border: 10px solid transparent;
    border-top-color: #fff;
    border-bottom: 0;
    margin-bottom: -10px;
  }
`;

const TooltipWrapper = styled.div`
  position: relative;
`;

const Title = styled.div`
  font-size: 20px;
  font-weight: 600;
  line-height: 1.4;
  color: #4a4a4a;
`;

const Description = styled.div`
  margin-top: 4px;
  font-size: 16px;
  line-height: 1.5;
  color: #4a4a4a;
`;

const Button = styled.div`
  font-weight: bold;
  background-color: #f78323;
  color: #fff;
  border-radius: 100px;
  border: solid 1px #f78323;
  line-height: 1.43;
  box-sizing: border-box;
  padding: 6px 23px;
  font-size: 14px;
  cursor: pointer;
  float: right;
  margin: 16px 8px 8px 0px;
`;

class WelcomeTooltip extends Component {
  static propTypes = {
    cookies: instanceOf(Cookies).isRequired,
  }

  constructor(props) {
    super(props);
    this.state = {
      show: this.props.show,
    };
    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
    scroller.scrollTo('welcome-tooltip', {
      duration: 1500,
      delay: 100,
      smooth: true,
      offset: -200,
    });
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }
  setWrapperRef(ref) {
    this.wrapperRef = ref;
  }
  handleClickOutside(event) {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.hideForever();
    }
  }

  hideForever() {
    const { onHide, cookies, pointOfSale } = this.props;
    this.setState({ show: false });
    onHide();
    const onboarding = cookies.get('osp-onboarding') || '';
    if (!onboarding.includes(pointOfSale)) {
      cookies.set('osp-onboarding', `${onboarding}.${pointOfSale}`);
    }
  }

  render() {
    const { show } = this.state;
    const { cookies, pointOfSale } = this.props;
    const onboarding = cookies.get('osp-onboarding') || '';
    const showTooltip = !onboarding.split('.').find(elem => elem === pointOfSale);

    return (
      <Container show={show && showTooltip}>
        <HeaderCoverScreen />
        <CoverScreen />
        <TooltipWrapper>
          <TooltipBubble name={show && showTooltip ? 'welcome-tooltip' : ''} ref={this.setWrapperRef}>
            <Title >Customize seu plano</Title>
            <Description>Agora você pode escolher a quantidade de anúncios e definir a melhor opção de plano para você. <span role="img" aria-label="Wink">😉</span></Description>
            <Button onClick={() => this.hideForever()}>Entendi</Button>
          </TooltipBubble>
        </TooltipWrapper>
      </Container>
    );
  }
}

WelcomeTooltip.propTypes = {
  show: bool,
  pointOfSale: string.isRequired,
  onHide: func,
};

WelcomeTooltip.defaultProps = {
  show: true,
  onHide: () => {},
};

export default withCookies(WelcomeTooltip);
